// src/components/common/Section.js
import React from 'react';

const Section = ({
  children,
  className = '',
  background = 'white',
  padding = 'normal',
  container = true,
  id,
  ...props
}) => {
  // Determine background classes
  const getBackgroundClasses = () => {
    switch (background) {
      case 'primary':
        return 'bg-primary text-white';
      case 'primary-dark':
        return 'bg-primary-dark text-white';
      case 'secondary':
        return 'bg-secondary text-white';
      case 'gray':
        return 'bg-gray-100 text-gray-800';
      case 'dark':
        return 'bg-gray-900 text-white';
        // absolute inset-0 bg-gradient-to-r from-primary-dark to-primary opacity-80
      case 'gradient-primary':
        return 'bg-gradient-to-r from-primary-dark to-primary opacity-80 text-white';
      case 'gradient-blue':
        return 'bg-gradient-to-r from-blue-900 to-blue-700 text-white';
      case 'white':
      default:
        return 'bg-white text-gray-800';
    }
  };
  
  // Determine padding classes
  const getPaddingClasses = () => {
    switch (padding) {
      case 'none':
        return 'py-0';
      case 'sm':
        return 'py-8';
      case 'lg':
        return 'py-20';
      case 'xl':
        return 'py-24';
      case 'normal':
      default:
        return 'py-16';
    }
  };
  
  // Combine all classes
  const sectionClasses = `
    ${getBackgroundClasses()}
    ${getPaddingClasses()}
    ${className}
  `;
  
  return (
    <section className={sectionClasses} id={id} {...props}>
      {container ? (
        <div className="container mx-auto px-4">{children}</div>
      ) : (
        children
      )}
    </section>
  );
};

export default Section;